import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import { CardText } from "../subComponents/cardText";

interface FlightAirportsProps {
  origin?: string;
  destination?: string;
  originTerminal?: string;
  destinationTerminal?: string;
}

export const FlightAirports = ({ origin, destination, originTerminal, destinationTerminal }: FlightAirportsProps) => {
  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack sx={{
        gap: "4px"
      }}>
        <CardText variant="bodySubtext" sx={{ lineHeight: "21px", maxWidth: "180px" }}>
          {origin}
        </CardText>
        {originTerminal && (
          <CardText variant="bodySubtext"> {`${cardTranslation("Terminal")} ${originTerminal}`}</CardText>
        )}
      </Stack>
      <Stack sx={{
        gap: "4px"
      }}>
        <CardText variant="bodySubtext" sx={{ lineHeight: "21px", textAlign: "end", maxWidth: "180px" }}>
          {destination}
        </CardText>
        {destinationTerminal && (
          <CardText variant="bodySubtext" sx={{ textAlign: "end" }}>
            {`${cardTranslation("Terminal")} ${destinationTerminal}`}
          </CardText>
        )}
      </Stack>
    </Stack>
  );
};
